import styled from "styled-components";
import theme from "../../../Styles/theme";


import {Container} from "../Sections/styles";


export {Container};

export const Table = styled.table`
width:100%;


`;

export const Tr = styled.tr`


`;

export const Th = styled.th`
color:${theme.colors.dark};
font-size: 12px;

        
`;


export const Td = styled.td`
color:${theme.colors.dark};
font-size: 11px;
border:solid 0.6px ${theme.colors.dark};   
padding: 0.2vh 1vw;

`;



